import useCallbackRef from '@polestar/component-warehouse-react/hooks/useCallbackRef';
import { mutableValue, } from '@polestar/component-warehouse-react/hooks/useMutableValue';
import { createContext, useContext } from 'react';
/**
 * @internal
 */
export const TableContext = createContext({
    internal: false,
    zebraStripes: false,
    columnSizes: [],
    stickyColumns: [],
    stickyHeader: false,
    hasThead: mutableValue(false),
});
/**
 * @internal
 */
export const useTable = () => {
    const { columnSizes, stickyColumns, stickyHeader, stickyOffsetHeight, hasThead, zebraStripes } = useContext(TableContext);
    const setColumnData = (index, width) => {
        if (columnSizes.length < index - 1) {
            columnSizes.splice(columnSizes.length, 0, ...new Array(index - columnSizes.length));
        }
        columnSizes[index] = width;
    };
    return {
        columnSizes: columnSizes.slice(0),
        stickyColumns,
        stickyHeader,
        stickyOffsetHeight,
        setColumnData,
        hasThead,
        zebraStripes,
    };
};
/**
 * @internal
 */
export const useTableColumnIndex = () => {
    var _a;
    const [ref, node] = useCallbackRef();
    let value = -1;
    if (node) {
        value = [
            // TODO: not sure why this failed with typescript :/
            // @ts-ignore
            ...(((_a = node === null || node === void 0 ? void 0 : node.parentNode) === null || _a === void 0 ? void 0 : _a.children) || []),
        ].indexOf(node);
    }
    return [ref, value];
};
